// extracted by mini-css-extract-plugin
export default {"card":"StatsCard_card__SFO07","icon":"StatsCard_icon__K8eKT","info":"StatsCard_info__ty5KQ","label":"StatsCard_label__ZaQVc","value":"StatsCard_value__B1l-p"};